import type { AbilityBuilder } from "@casl/ability"

import type { TAppAbility } from "./index"
import type { TUser } from "./models/user"
import type { TRole } from "./roles"

type TPermissionsByRole = (
  user: TUser,
  builder: AbilityBuilder<TAppAbility>,
) => void

export const permissions: Record<TRole, TPermissionsByRole> = {
  admin(_user, { can }) {
    can("manage", "all")
  },
  member() {},
}
